module.exports = __webpack_public_path__ + "static/codehavenblog-1229f8b2eb1740935b966b14cd87e7f8.png";